/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * When the output connection fires
 * @export
 */
export const GamificationOutputEventTrigger = {
    MILESTONE: 'MILESTONE',
    COMPLETION: 'COMPLETION'
} as const;
export type GamificationOutputEventTrigger = typeof GamificationOutputEventTrigger[keyof typeof GamificationOutputEventTrigger];


export function instanceOfGamificationOutputEventTrigger(value: any): boolean {
    for (const key in GamificationOutputEventTrigger) {
        if (Object.prototype.hasOwnProperty.call(GamificationOutputEventTrigger, key)) {
            if (GamificationOutputEventTrigger[key as keyof typeof GamificationOutputEventTrigger] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GamificationOutputEventTriggerFromJSON(json: any): GamificationOutputEventTrigger {
    return GamificationOutputEventTriggerFromJSONTyped(json, false);
}

export function GamificationOutputEventTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationOutputEventTrigger {
    return json as GamificationOutputEventTrigger;
}

export function GamificationOutputEventTriggerToJSON(value?: GamificationOutputEventTrigger | null): any {
    return value as any;
}

export function GamificationOutputEventTriggerToJSONTyped(value: any, ignoreDiscriminator: boolean): GamificationOutputEventTrigger {
    return value as GamificationOutputEventTrigger;
}

